import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Grid from "@mui/material/Grid";
import AuthContext from "../../context/AuthContext";
import Select from "react-dropdown-select";
import { createTheme } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PollType, ThreadType, TopicType, UserType } from "../../utils/types";
import TextEditor from "./TextEditor";

const ThreadEditForm = ({ initialThread }: { initialThread: ThreadType }) => {
  let { user } = useContext(AuthContext);
  const currentUser: UserType = user;

  const [alertShow, setAlertShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [topics, setTopics] = useState<TopicType[]>([]);
  const [thread, setThread] = useState<ThreadType>(
    initialThread || {
      subject: "",
      content: "",
      topic: { id: 0, label: "", creator: "", creator_id: 0 },
      creator: currentUser,
    }
  );
  const [poll, setPoll] = useState<PollType>(null);
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddOption = () => {
    setPoll({
      ...poll,
      options: [
        ...poll.options,
        {
          option_text: "",
          id: null,
          votes: "",
        },
      ],
    });
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...poll.options];
    newOptions[index].option_text = value;
    setPoll({ ...poll, options: newOptions });
  };

  useEffect(() => {
    const fetchPoll = async () => {
      const response = await fetch(`/api/threads/${thread.id}/poll/`);
      const data = await response.json();
      if (response.ok) {
        setPoll(data);
      }
    };
    fetchPoll();
  }, [thread]);

  let handleThread = async (event) => {
    event.preventDefault();
    const response = await fetch(`/api/updateThread/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(thread),
    });

    const data = await response.json();
    if (poll) {
      try {
        const pollResponse = await fetch(`/api/threads/${data.id}/poll/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: poll.id,
            question: poll.question,
            is_anonymous: poll.is_anonymous,
            options: poll.options,
          }),
        });
      } catch (error) {
        console.error(error);
      }
    }
    window.location.reload();
  };

  return thread ? (
    <div>
      <Grid container justifyContent="flex-end">
        <Button
          variant="outlined"
          onClick={handleClickOpen}
          style={{
            maxWidth: "180px",
            maxHeight: "32px",
            minWidth: "100px",
            minHeight: "32px",
          }}
        >
          Bearbeiten
        </Button>
      </Grid>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <form onSubmit={handleThread} id="NewThreadForm">
          <Box>
            {alertShow && (
              <Alert severity="error" onClose={() => setAlertShow(false)}>
                Bitte melde dich an um einen Beitrag zu bearbeiten.{" "}
                <Link href="/login">Hier anmelden.</Link>
              </Alert>
            )}
          </Box>

          <DialogTitle>Beitrag bearbeiten</DialogTitle>
          <DialogContent>
            <TextField
              style={{
                marginTop: 20,
              }}
              required
              autoFocus
              margin="dense"
              id="subject"
              name="subject"
              label="Titel"
              type="text"
              fullWidth
              variant="standard"
              value={thread.subject}
              onChange={(e) => {
                setThread({ ...thread, subject: e.target.value });
              }}
            />

            <TextEditor
              onChange={(value) => {
                setThread({
                  ...thread,
                  content: value,
                });
              }}
              value={thread.content}
              placeholder={thread.content}
            />

            {poll && (
              <>
                <TextField
                  margin="dense"
                  label="Umfrage Fragestellung"
                  type="text"
                  fullWidth
                  value={poll.question}
                  onChange={(e) =>
                    setPoll({ ...poll, question: e.target.value })
                  }
                />
                {poll.options?.map((option, index) => (
                  <TextField
                    key={index}
                    margin="dense"
                    label={`Option ${index + 1}`}
                    type="text"
                    fullWidth
                    value={option.option_text}
                    onChange={(e) => handleOptionChange(index, e.target.value)}
                  />
                ))}
                <Button onClick={handleAddOption}>Option hinzufügen </Button>
              </>
            )}
          </DialogContent>

          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={handleClose}>
                Abbrechen
              </Button>
              <Button variant="contained" endIcon={<SendIcon />} type="submit">
                Speichern
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  ) : (
    <></>
  );
};

export default ThreadEditForm;
